<script setup lang="ts">
import { BrandWhatsappIcon } from 'vue-tabler-icons';
</script>
<template>
  <v-footer class="footer-pro">
    <v-container>
      <v-divider class="mb-4" />
      <v-row align="center" justify="space-between" class="py-2">
        <v-col cols="12" md="6" class="text-center text-md-left">
          <div class="footer-brand">ભોજાણી પરિવાર</div>
          <div class="footer-subtext">કડવા પાટીદાર</div>
          <div class="footer-sub">Villages • Families • People</div>
        </v-col>
        <v-col cols="12" md="6" class="text-center text-md-right">
          <div class="footer-legal">All rights reserved © Raj Bhojani</div>
          <a
            class="footer-contact"
            href="https://wa.me/918849599423"
            target="_blank"
            rel="noopener"
          >
            <BrandWhatsappIcon size="18" stroke-width="1.7" class="whatsapp-icon" />
            <span>+91 88495 99423</span>
          </a>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<style lang="scss">
.v-footer {
  position: unset;
}
.footer-pro {
  background: linear-gradient(180deg, rgba(250, 250, 250, 0.6), #fff);
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
.footer-brand {
  font-weight: 700;
  font-size: 1rem;
  color: rgb(var(--v-theme-secondary));
  letter-spacing: 0.4px;
}
.footer-subtext {
  font-size: 0.9rem;
  font-weight: 600;
  color: rgb(var(--v-theme-primary));
}
.footer-sub {
  font-size: 0.8rem;
  color: rgb(var(--v-theme-lightText));
}
.footer-legal {
  font-size: 0.85rem;
  color: rgb(var(--v-theme-darkText));
}
.footer-contact {
  margin-top: 6px;
  font-size: 0.85rem;
  color: rgb(var(--v-theme-darkText));
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
}
.footer-contact:hover {
  text-decoration: underline;
}
.whatsapp-icon {
  color: #25d366;
}
</style>
